// extracted by mini-css-extract-plugin
export var active = "_if-e";
export var blink = "_if-f";
export var dropDownSelector = "_if-5";
export var dropDownWrapper = "_if-4";
export var fakeCursor = "_if-d";
export var fontSizeButton = "_if-7";
export var formQuillEditor = "_if-0";
export var pressed = "_if-g";
export var qlBlank = "_if-1";
export var textFormattingToolbar = "_if-2";
export var textFormattingToolbarClosed = "_if-3";
export var textFormattingToolbarInline = "_if-6";
export var textToolbarOption = "_if-8";
export var toolbarCell = "_if-a";
export var toolbarCellCollapsed = "_if-b";
export var toolbarOptionHitArea = "_if-c";
export var toolbarOverflow = "_if-9";